/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { MdLibraryAdd } from "react-icons/md";
import { apiPath, RoutePath } from "../../utility/Constant";
import { useState } from "react";
import { deleteData } from "../../hooks/delete";

const BlogCard = ({ blog, user }) => {
  const [hidden, setHidden] = useState(false);
  const { addBlog } = RoutePath;
  const { blogListApi } = apiPath;
  const handleDelete = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(`${blogListApi}/${event.target.id}`);
        setTimeout(() => {
          setHidden(true);
        }, 1000);
      }
    });
  };
  return (
    <div className={hidden && "hidden"}>
      {blog ? (
        <div className="card bg-base-100 shadow-xl">
          <figure>
            <img
              src={blog.img}
              alt="blog"
              className="h-[200px] object-cover w-full"
            />
          </figure>

          <div className="p-3">
            <h2 className="text-md text-center uppercase font-semibold">
              {blog.blogTitle.length > 45
                ? blog.blogTitle.slice(0, 45) + "..."
                : blog.blogTitle}
            </h2>
            <div className="flex justify-center">
              <p className="btn btn-link text-gray-600">{blog.category}</p>
            </div>

            <div className="card-actions justify-between">
              <Link
                to={`/blogList/${blog._id}`}
                className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white"
              >
                Edit
              </Link>
              {user === "admin" && (
                <button
                  id={blog._id}
                  onClick={handleDelete}
                  className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Link
          to={addBlog}
          className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
        >
          <p className="text-8xl">
            <MdLibraryAdd />
          </p>
        </Link>
      )}
    </div>
  );
};

export default BlogCard;
